import { For, createMemo } from 'solid-js';
import { AttendanceRecord } from './AttendanceRecord';
import { requireAttendanceGridContext } from '../st-attendance-grid';
import styles from '../st-attendance-grid.module.css';

export function Day(props: { date: Date, sectGU: string }) {
    const ctx = requireAttendanceGridContext();

    return <WeeklyDay {...props} />;
}

function WeeklyDay(props: { date: Date; sectGU: string }) {
    const ctx = requireAttendanceGridContext();
    const attendance = createMemo(() => ctx.getAttendance(props.date, props.sectGU));

    return <div class={styles['weekly-day']}>
        <div class={styles['weekly-day-date']}>
            {props.date.getDate()}
        </div>
        <For each={attendance()}>{att =>
            <AttendanceRecord {...att} calDate={props.date} />
        }</For>
    </div>
}
